import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useAppDispatch } from 'hooks/useSelectors';
import { useEffect } from 'react';

import { handleError } from '../thunks/error';

export const useRTKQErrorHandler = (
  error: FetchBaseQueryError | SerializedError | unknown | undefined
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (error) dispatch(handleError(error));
  }, [dispatch, error]);
};
